import ScreenController from 'screens/ScreenController';

class EntryScreen extends ScreenController {
  constructor() {
    super();
  }
}

export default EntryScreen;
